import React from "react";

function Page3() {
  return (
    <div className="page-container">
      <div
        className="page"
        style={{
          width: "93%",
          height: "1209px",
          margin: "20px auto 20px auto",
          boxShadow: "0 0 2rem 0 rgba(136, 152, 170, 0.5)",
        }}
      >
        <div
          id="pg3Overlay"
          style={{
            WebkitUserSelect: "none",
            backgroundColor: "rgba(0,0,0,0)",
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: "1",
          }}
        />
        <div className="text-container">
          <span
            className="t s0"
            style={{
              bottom: "1138px",
              left: "55px",
              letterSpacing: "-0.15px",
            }}
          >
            Form W-9 (Rev. 3-2024){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1137px",
              left: "844px",
              letterSpacing: "-0.14px",
            }}
          >
            Page{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "1135px",
              left: "872px",
            }}
          >
            3{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "67px",
              letterSpacing: "0.11px",
            }}
          >
            Certain payees and payments are exempt from backup withholding.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            See{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "1092px",
              left: "79px",
              letterSpacing: "0.12px",
            }}
          >
            Exempt payee code
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "188px",
              letterSpacing: "0.09px",
            }}
          >
            , later, and the separate Instructions for the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1079px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Requester of Form W-9 for more information.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1060px",
              left: "67px",
              letterSpacing: "0.09px",
            }}
          >
            See also{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "1060px",
              left: "117px",
              letterSpacing: "0.1px",
            }}
          >
            Establishing U.S. status for purposes of chapter 3 and{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "1047px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            chapter 4 withholding
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1047px",
              left: "173px",
              letterSpacing: "0.08px",
            }}
          >
            , earlier.{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "1013px",
              left: "55px",
              letterSpacing: "0.18px",
            }}
          >
            What Is FATCA Reporting?{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "996px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            The Foreign Account Tax Compliance Act (FATCA) requires a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "982px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            participating foreign financial institution to report all U.S.
            account{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "969px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            holders that are specified U.S. persons. Certain payees are exempt
            from{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "955px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            FATCA reporting. See{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "955px",
              left: "178px",
              letterSpacing: "0.11px",
            }}
          >
            Exemption from FATCA reporting code
          </span>
          <span
            className="t s6"
            style={{
              bottom: "955px",
              left: "390px",
              letterSpacing: "0.08px",
            }}
          >
            , later, and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "941px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            the Instructions for the Requester of Form W-9 for more information.{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "911px",
              left: "55px",
              letterSpacing: "0.17px",
            }}
          >
            Updating Your Information{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "894px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            You must provide updated information to any person to whom you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "880px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            claimed to be an exempt payee if you are no longer an exempt payee{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "866px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            and anticipate receiving reportable payments in the future from this{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "853px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            person. For example, you may need to provide updated information if{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "839px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            you are a C corporation that elects to be an S corporation, or if
            you are{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "825px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            no longer tax exempt. In addition, you must furnish a new Form W-9
            if{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "811px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            the name or TIN changes for the account, for example, if the grantor
            of a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "798px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            grantor trust dies.{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "768px",
              left: "55px",
              letterSpacing: "0.16px",
            }}
          >
            Penalties{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "750px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            Failure to furnish TIN.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "750px",
              left: "184px",
              letterSpacing: "0.09px",
            }}
          >
            If you fail to furnish your correct TIN to a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "736px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            requester, you are subject to a penalty of $50 for each such{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "736px",
              left: "384px",
              letterSpacing: "0.08px",
            }}
          >
            failure{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "723px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            unless your failure is due to reasonable cause and not to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "723px",
              left: "367px",
              letterSpacing: "0.09px",
            }}
          >
            willful neglect.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "704px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Civil penalty for false information with respect to withholding.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "704px",
              left: "416px",
              letterSpacing: "0.08px",
            }}
          >
            If you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "691px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            make a false statement with no reasonable{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "691px",
              left: "292px",
              letterSpacing: "0.09px",
            }}
          >
            basis that results in no{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "677px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            backup withholding, you are subject to a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "677px",
              left: "280px",
              letterSpacing: "0.1px",
            }}
          >
            $500 penalty.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "659px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Criminal penalty for falsifying information.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "659px",
              left: "302px",
              letterSpacing: "0.08px",
            }}
          >
            Willfully falsifying{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "645px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            certifications or affirmations may subject you to criminal{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "645px",
              left: "363px",
              letterSpacing: "0.09px",
            }}
          >
            penalties{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "631px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            including fines and/or imprisonment.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "613px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Misuse of TINs.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "613px",
              left: "148px",
              letterSpacing: "0.1px",
            }}
          >
            If the requester discloses or uses TINs in{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "613px",
              left: "374px",
              letterSpacing: "0.08px",
            }}
          >
            violation of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "599px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            federal law, the requester may be subject to civil and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "599px",
              left: "346px",
              letterSpacing: "0.09px",
            }}
          >
            criminal penalties.{" "}
          </span>
          <span
            className="t sc"
            style={{
              bottom: "562px",
              left: "55px",
              letterSpacing: "0.18px",
            }}
          >
            Specific Instructions{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "539px",
              left: "55px",
              letterSpacing: "0.13px",
            }}
          >
            Line 1{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "521px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            You must enter one of the following on this line;{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "521px",
              left: "318px",
              letterSpacing: "0.11px",
            }}
          >
            do not{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "521px",
              left: "359px",
              letterSpacing: "0.08px",
            }}
          >
            leave this line{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "507px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            blank.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "507px",
              left: "91px",
              letterSpacing: "0.11px",
            }}
          >
            The name should match the name on your tax return.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "489px",
              left: "67px",
              letterSpacing: "0.09px",
            }}
          >
            If this Form W-9 is for a joint account (other than an account{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "475px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            maintained by a foreign financial institution (FFI)), list first,
            and then{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "461px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            circle, the name of the person or entity whose number you entered in{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "448px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Part I of Form W-9. If you are providing Form W-9 to an FFI to
            document{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "434px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            a joint account, each holder of the account that is a U.S. person
            must{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "420px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            provide a Form W-9.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "402px",
              left: "55px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "402px",
              left: "65px",
              letterSpacing: "0.09px",
            }}
          >
            Individual.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "402px",
              left: "127px",
              letterSpacing: "0.1px",
            }}
          >
            Generally, enter the name shown on your tax return. If you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "388px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            have changed your last name without informing the Social Security{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "374px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Administration (SSA) of the name change, enter your first name, the
            last{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "361px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            name as shown on your social security card, and your new last name.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "342px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Note for ITIN applicant:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "342px",
              left: "194px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your individual name as it was entered{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "329px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            on your Form W-7 application, line 1a. This should also be the same
            as{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "315px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            the name you entered on the Form 1040 you filed with your
            application.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "296px",
              left: "55px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "296px",
              left: "65px",
              letterSpacing: "0.1px",
            }}
          >
            Sole proprietor.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "296px",
              left: "159px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your individual name as shown on your Form{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "283px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            1040 on line 1. Enter your{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "283px",
              left: "198px",
              letterSpacing: "0.1px",
            }}
          >
            business, trade, or “doing business as” (DBA){" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "269px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            name on line 2.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "251px",
              left: "55px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "251px",
              left: "65px",
              letterSpacing: "0.1px",
            }}
          >
            Partnership, C corporation, S corporation, or LLC, other than a{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "237px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            disregarded entity.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "237px",
              left: "168px",
              letterSpacing: "0.1px",
            }}
          >
            Enter the entity’s name as shown on the entity’s tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "223px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            return on line 1 and any business, trade, or DBA name on line 2.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "205px",
              left: "55px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "205px",
              left: "65px",
              letterSpacing: "0.09px",
            }}
          >
            Other entities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "205px",
              left: "150px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your name as shown on required U.S. federal tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "191px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            documents on line 1. This name should match the name shown on the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "177px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            charter or other legal document creating the entity. Enter any
            business,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "164px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            trade, or DBA name on line 2.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "145px",
              left: "55px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "145px",
              left: "65px",
              letterSpacing: "0.1px",
            }}
          >
            Disregarded entity.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "145px",
              left: "179px",
              letterSpacing: "0.09px",
            }}
          >
            In general, a business entity that has a single{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "131px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            owner, including an LLC, and is not a corporation, is disregarded as
            an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "118px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            entity separate from its owner (a disregarded entity). See
            Regulations{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "104px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            section 301.7701-2(c)(2). A disregarded entity should check the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "90px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            appropriate box for the tax classification of its owner. Enter the
            owner’s{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "76px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            name on line 1. The name of the owner entered on line 1 should never{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "63px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            be a disregarded entity. The name on line 1 should be the name shown{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "49px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            on the income tax return on which the income should be reported. For{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            example, if a foreign LLC that is treated as a disregarded entity
            for U.S.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            federal tax purposes has a single owner that is a U.S. person, the
            U.S.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1079px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            owner’s name is required to be provided on line 1. If the direct
            owner of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1065px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            the entity is also a disregarded entity, enter the first owner that
            is not{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1051px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            disregarded for federal tax purposes. Enter the disregarded entity’s{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1037px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            name on line 2. If the owner of the disregarded entity is a foreign
            person,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1024px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            the owner must complete an appropriate Form W-8 instead of a Form{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1010px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            W-9.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1010px",
              left: "517px",
              letterSpacing: "0.09px",
            }}
          >
            This is the case even if the foreign person has a U.S. TIN.{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "985px",
              left: "484px",
              letterSpacing: "0.13px",
            }}
          >
            Line 2{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "967px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            If you have a business name, trade name, DBA name, or disregarded{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "953px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            entity name, enter it on line 2.{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "928px",
              left: "484px",
              letterSpacing: "0.14px",
            }}
          >
            Line 3a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "911px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Check the appropriate box on line 3a for the U.S. federal tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "897px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            classification of the person whose name is entered on line 1. Check
            only{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "883px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            one box on line 3a.{" "}
          </span>
          <span
            className="t s3 w-100"
            style={{
              left: "490px",
              bottom: "859px",
              letterSpacing: "0.09px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "188px",
                left: "-9px",
                height: "223px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
            <hr
              className="t s3"
              style={{
                top: "-36px",
                left: "-10px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            IF the entity/individual on line 1{" "}
            <hr
              className="t s3"
              style={{
                top: "188px",
                left: "189px",
                height: "223px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
          </span>
          <span
            className="t s3"
            style={{
              bottom: "845px",
              left: "490px",
              letterSpacing: "0.08px",
            }}
          >
            is a(n) . . .{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "859px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            THEN check the box for . . .{" "}
            <hr
              className="t s3"
              style={{
                top: "188px",
                left: "191px",
                height: "223px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
          </span>
          <span
            className="t s6"
            style={{
              bottom: "824px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "824px",
              left: "500px",
              letterSpacing: "0.11px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-33px",
                left: "-20px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Corporation{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "824px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            Corporation.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "805px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "805px",
              left: "500px",
              letterSpacing: "0.09px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-33px",
                left: "-20px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Individual or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "787px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "787px",
              left: "500px",
              letterSpacing: "0.1px",
            }}
          >
            Sole proprietorship{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "805px",
              left: "688px",
              letterSpacing: "0.09px",
            }}
          >
            Individual/sole proprietor.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "769px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "769px",
              left: "500px",
              letterSpacing: "0.1px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-33px",
                left: "-20px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            LLC classified as a partnership{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "755px",
              left: "487px",
              letterSpacing: "0.09px",
            }}
          >
            for U.S. federal tax purposes or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "736px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "736px",
              left: "500px",
              letterSpacing: "0.1px",
            }}
          >
            LLC that has filed Form 8832 or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "723px",
              left: "487px",
              letterSpacing: "0.1px",
            }}
          >
            2553 electing to be taxed as a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "709px",
              left: "487px",
              letterSpacing: "0.1px",
            }}
          >
            corporation{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "769px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            Limited liability company and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "755px",
              left: "688px",
              letterSpacing: "0.09px",
            }}
          >
            enter the appropriate tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "741px",
              left: "688px",
              letterSpacing: "0.08px",
            }}
          >
            classification:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "724px",
              left: "688px",
              letterSpacing: "0.09px",
            }}
          >
            P = Partnership,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "710px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            C = C corporation, or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "697px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            S = S corporation.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "677px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "677px",
              left: "500px",
              letterSpacing: "0.1px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-33px",
                left: "-20px",
                height: "0%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Partnership{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "677px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            Partnership.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "659px",
              left: "487px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6 w-100"
            style={{
              bottom: "659px",
              left: "500px",
              letterSpacing: "0.1px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-33px",
                left: "-20px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Trust/estate{" "}
            <hr
              className="t s3"
              style={{
                top: "-13px",
                left: "-20px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s6"
            style={{
              bottom: "659px",
              left: "688px",
              letterSpacing: "0.1px",
            }}
          >
            Trust/estate.{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "631px",
              left: "484px",
              letterSpacing: "0.14px",
            }}
          >
            Line 3b{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "613px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Check this box if you are a partnership (including an LLC classified
            as a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "599px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            partnership for U.S. federal tax purposes), trust, or estate that
            has any{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "585px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            foreign partners, owners, or beneficiaries, and you are providing
            this{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "571px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            form to a partnership, trust, or estate, in which you have an
            ownership{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "558px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            interest. You must check the box on line 3b if you receive a Form
            W-8{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "544px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            (or documentary evidence) from any partner, owner, or beneficiary{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "530px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            establishing foreign status or if you receive a Form W-9 from any{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "516px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            partner, owner, or beneficiary that has checked the box on line 3b.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "498px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "498px",
              left: "519px",
              letterSpacing: "0.1px",
            }}
          >
            A partnership that provides a Form W-9 and checks box 3b may{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "484px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            be required to complete Schedules K-2 and K-3 (Form 1065). For more{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "471px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            information, see the Partnership Instructions for Schedules K-2 and
            K-3{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "457px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            (Form 1065).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "439px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            If you are required to complete line 3b but fail to do so, you may
            not{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "425px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            receive the information necessary to file a correct information
            return with{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "411px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            the IRS or furnish a correct payee statement to your partners or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "397px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            beneficiaries. See, for example, sections 6698, 6722, and 6724 for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "384px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            penalties that may apply.{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "359px",
              left: "484px",
              letterSpacing: "0.14px",
            }}
          >
            Line 4 Exemptions{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "341px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            If you are exempt from backup withholding and/or FATCA reporting,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "327px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            enter in the appropriate space on line 4 any code(s) that may apply
            to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "313px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            you.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "295px",
              left: "484px",
              letterSpacing: "0.12px",
            }}
          >
            Exempt payee code.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "277px",
              left: "484px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "277px",
              left: "497px",
              letterSpacing: "0.1px",
            }}
          >
            Generally, individuals (including sole proprietors) are not exempt
            from{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "263px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            backup withholding.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "244px",
              left: "484px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "244px",
              left: "497px",
              letterSpacing: "0.1px",
            }}
          >
            Except as provided below, corporations are exempt from backup{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "231px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            withholding for certain payments, including interest and dividends.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "212px",
              left: "484px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "212px",
              left: "497px",
              letterSpacing: "0.1px",
            }}
          >
            Corporations are not exempt from backup withholding for payments{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "199px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            made in settlement of payment card or third-party network
            transactions.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "180px",
              left: "484px",
            }}
          >
            •{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "180px",
              left: "497px",
              letterSpacing: "0.1px",
            }}
          >
            Corporations are not exempt from backup withholding with respect to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "167px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            attorneys’ fees or gross proceeds paid to attorneys, and
            corporations{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "153px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            that provide medical or health care services are not exempt with
            respect{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "139px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            to payments reportable on Form 1099-MISC.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "121px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            The following codes identify payees that are exempt from backup{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "107px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            withholding. Enter the appropriate code in the space on line 4.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "89px",
              left: "492px",
              letterSpacing: "0.1px",
            }}
          >
            1—An organization exempt from tax under section 501(a), any IRA, or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "75px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            a custodial account under section 403(b)(7) if the account satisfies
            the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "61px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            requirements of section 401(f)(2).{" "}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Page3;
